// esbuild entry: bundle front-end JS modules
// Register submodules that augment the UI
import './toc.js';
import './shuffle.js';
import './reveal.js';
import './audio.js';
import './lightbox.js';
import './external-links.js';
import './theme.js';
